import { Component, inject } from '@angular/core';
import { Hero } from './controls/hero/hero';
import { Network } from './controls/network/network';
import { Meta, Title } from '@angular/platform-browser';
import { CommunityBenifits } from './controls/community-benifits/community-benifits';

@Component({
  selector: 'app-home',
  imports: [Hero, CommunityBenifits],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  constructor() {
    this.title.setTitle('SoniBiz | Business & Professional Network for the Soni Community');

    this.meta.updateTag({
      name: 'description',
      content:
        'SoniBiz connects Soni business owners, professionals, entrepreneurs, service providers and future leaders through trusted networking, referrals, partnerships and growth opportunities.',
    });

    this.meta.updateTag({
      name: 'keywords',
      content:
        'Soni community, Soni business network, Soni entrepreneurs, Soni professionals, business networking, referrals, partnerships, mentorship',
    });

    this.meta.updateTag({
      property: 'og:title',
      content: 'SoniBiz | Business & Professional Network for the Soni Community',
    });

    this.meta.updateTag({
      property: 'og:description',
      content:
        'Connect with trusted business owners, professionals and entrepreneurs from the Soni community.',
    });

    this.meta.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.meta.updateTag({
      name: 'twitter:title',
      content: 'SoniBiz | Business & Professional Network for the Soni Community',
    });

    this.meta.updateTag({
      name: 'twitter:description',
      content:
        'Discover opportunities, referrals, partnerships and growth through a trusted Soni business network.',
    });
  }
}
